import script from "./client-card-view.vue?vue&type=script&setup=true&lang=js"
export * from "./client-card-view.vue?vue&type=script&setup=true&lang=js"

import "./client-card-view.vue?vue&type=style&index=0&id=ee653608&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee653608"]])

export default __exports__